module.exports = __webpack_public_path__ + "static/media/fashion.831896ed.png";